import { type WebV1SurveysTriggersListData } from '@credit-web/services/product-journey-girar'
import { type TransformTypesToCamelCase } from '@credit-web/services/types'
import camelcaseKeys from 'camelcase-keys'

/**
 * GET:/api/web/v1/surveys/triggers
 */
export const webV1SurveysTriggersListData: WebV1SurveysTriggersListData = {
  content: [
    {
      survey_id: 'fedcba98-7654-3210-fedc-ba9876543210',
      survey_key: '<chave_unica>',
      events_name: ['cart-abandoned', 'storie-clicked']
    },
    {
      survey_id: 'fedcba98-7654-3210-fedc-ba9876543210',
      survey_key: '<chave_unica>',
      events_name: ['cart-abandoned', 'storie-clicked']
    },
    {
      survey_id: 'fedcba98-7654-3210-fedc-ba9876543210',
      survey_key: '<chave_unica>',
      events_name: ['cart-abandoned', 'storie-clicked']
    }
  ],
  trace_key: 'sak_07294901329',
  is_valid: true
}

/**
 * GET:/api/web/v1/surveys/triggers
 */
export const webV1SurveysTriggersListDataTransformed = () =>
  camelcaseKeys(webV1SurveysTriggersListData, {
    deep: true
  }) as TransformTypesToCamelCase<WebV1SurveysTriggersListData>
